<template>
  <div class="main-page">
    <m-title></m-title>
    <div class="cont">
    <div class="card-list">
      <div class="card1">
        <div class="card-title">
          <span class="type">平台车辆</span>
          <span class="number">{{ CarStatistics.platCarCount }}</span>
        </div>
        <div class="electric-block">
          <div class="row" @click="goenergycar('1')">
            <span class="type">电车</span>
            <span class="number">{{ CarStatistics.platEleCarCount }}</span>
          </div>
        </div>
        <div class="hydrogen-block">
          <div class="row" @click="goenergycar('2')">
            <span class="type">氢车</span>
            <span class="number">{{ CarStatistics.platHydCarCount }}</span>
          </div>
        </div>
      </div>
      <div class="card2">
        <div class="card-title">
          <span class="type">作业中车辆</span>
          <span class="number">{{ CarStatistics.workCarCount }}</span>
        </div>
        <div class="electric-block">
          <div class="row" @click="goenergycar('1','A')">
            <span class="type">电车</span>
            <span class="number">{{ CarStatistics.workEleCarCount }}</span>
          </div>
        </div>
        <div class="hydrogen-block">
          <div class="row" @click="goenergycar('2','A')">
            <span class="type">氢车</span>
            <span class="number">{{ CarStatistics.workHydCarCount }}</span>
          </div>
        </div>
      </div>
      <div class="card5">
        <div class="desc-title" style="margin-top: 20px;">
          <div class="icon"></div>
          电车电量
        </div>
        <div class="card_cont">
          <div class="card_item1">
            <span class="num">{{ CarStatistics.soc100CarCount }}</span>
            <span class="name">100%-80%</span>
          </div> 
          <div class="card_item2">
            <span class="num">{{ CarStatistics.soc80CarCount }}</span>
            <span class="name">80%-60%</span>
          </div> 
          <div class="card_item3">
            <span class="num">{{ CarStatistics.soc60CarCount }}</span>
            <span class="name">60%-40%</span>
          </div> 
          <div class="card_item4">
            <span class="num">{{ CarStatistics.soc40CarCount }}</span>
            <span class="name">40%-20%</span>
          </div> 
          <div class="card_item5">
            <span class="num">{{ CarStatistics.soc20CarCount }}</span>
            <span class="name">20%-10%</span>
          </div> 
        </div>
      </div>
      <!-- <div class="card3">
        <div class="card-title">
          <span class="type">启动中车辆</span>
          <span class="number">{{ CarStatistics.startCarCount }}</span>
        </div>
        <div class="electric-block">
          <div class="row" @click="goenergycar('1','B')">
            <span class="type">电车</span>
            <span class="number">{{ CarStatistics.startEleCarCount }}</span>
          </div>
        </div>
        <div class="hydrogen-block">
          <div class="row" @click="goenergycar('2','B')">
            <span class="type">氢车</span>
            <span class="number">{{ CarStatistics.startHydCarCount }}</span>
          </div>
        </div>
      </div>
      <div class="card4">
        <div class="card-title">
          <span class="type">作业中启动车辆</span>
          <span class="number">{{ CarStatistics.workStartCarCount }}</span>
        </div>
        <div class="electric-block">
          <div class="row" @click="goenergycar('1','C')">
            <span class="type">电车</span>
            <span class="number">{{ CarStatistics.workStartEleCarCount }}</span>
          </div>
        </div>
        <div class="hydrogen-block">
          <div class="row" @click="goenergycar('2','C')">
            <span class="type">氢车</span>
            <span class="number">{{ CarStatistics.workStartHydCarCount }}</span>
          </div>
        </div>
      </div> -->
    </div>
    <div class="card-list" v-for="(item,index) in shortlist" :key="index">
      <!-- <img src="../../assets/statistics/pic_01.png" style="width: 242px; height: 168px"/> -->
      <div class="img">
        <div class="img-title">{{ item.shortname }}</div>
      </div>
      <div class="desc-list">
        <div class="desc-title">{{ item.shortname }}</div>
        <div class="desc-item" @click="goFleetList(item.shortname)">
          <div class="item-label">车队车数:</div>
          {{ item.platCarCount }}
        </div>
        <div class="desc-item" @click="goFleetList(item.shortname,1)">
          <div class="item-label">电车车数:</div>
          {{ item.platEleCarCount }}
        </div>
        <div class="desc-item" @click="goFleetList(item.shortname,2)">
          <div class="item-label">氢车车数:</div>
          {{ item.platHydCarCount }}
        </div>
      </div>
      <div class="desc-list">
        <div class="desc-title">
          <div class="icon"></div>
          车辆运行状态
        </div>
        <div class="status-row">
          <div class="status-item" @click="goenergycar('1','B',item.shortname)">
            <div class="status-label">启动状态电车</div>
            {{ item.startEleCarCount }}
          </div>
          <div class="status-item" @click="goenergycar('2','B',item.shortname)">
            <div class="status-label">启动状态氢车</div>
            {{ item.startHydCarCount }}
          </div>
        </div>
        <div class="status-row">
          <div class="status-item" @click="goenergycar('1','D',item.shortname)">
            <div class="status-label">熄火状态电车</div>
            {{ item.stopEleCarCount }}
          </div>
          <div class="status-item" @click="goenergycar('2','D',item.shortname)">
            <div class="status-label">熄火状态氢车</div>
            {{ item.stopHydCarCount }}
          </div>
        </div>
        <div class="status-row">
          <div class="status-item" @click="goenergycar('1','E',item.shortname)">
            <div class="status-label">其他状态电车</div>
            {{ item.qitaEleCarCount }}
          </div>
          <div class="status-item" @click="goenergycar('2','E',item.shortname)">
            <div class="status-label">其他状态氢车</div>
            {{ item.qitaHydCarCount }}
          </div>
        </div>
      </div>
      <div class="desc-list">
        <div class="desc-title">
          <div class="icon"></div>
          作业状态
        </div>
        <div class="status-row">
          <div class="status-item" style="cursor:default">
            <div class="status-label">作业中车辆</div>
            {{ item.workCarCount }}
          </div>
          <div class="status-item" style="cursor:default">
            <div class="status-label">作业中启动车辆</div>
            {{ item.workStartCarCount }}
          </div>
        </div>
        <div class="status-row">
          <div class="status-item" @click="goenergycar('1','A',item.shortname)">
            <div class="status-label">作业中电车</div>
            {{ item.workEleCarCount }}
          </div>
          <div class="status-item" @click="goenergycar('1','C',item.shortname)">
            <div class="status-label">作业中启动电车</div>
            {{ item.workStartEleCarCount }}
          </div>
        </div>
        <div class="status-row">
          <div class="status-item" @click="goenergycar('2','A',item.shortname)">
            <div class="status-label">作业中氢车</div>
            {{ item.workHydCarCount }}
          </div>
          <div class="status-item" @click="goenergycar('2','C',item.shortname)">
            <div class="status-label">作业中启动氢车</div>
            {{ item.workStartHydCarCount }}
          </div>
        </div>
      </div>
      <div class="desc-list elec">
        <div class="desc-title">
          <div class="icon"></div>
          电车电量
        </div>
        <div class="status-row">
          <div class="status-item bg1"  @click="goenergycarStore(100,item.shortname)">
            <div class="status-label">100%~80%电量</div>
            {{ item.soc100CarCount }}
          </div>
          <div class="status-item bg2" @click="goenergycarStore(80,item.shortname)">
            <div class="status-label">80%~60%电量</div>
            {{ item.soc80CarCount }}
          </div>
        </div>
        <div class="status-row">
          <div class="status-item bg3" @click="goenergycarStore(60,item.shortname)">
            <div class="status-label">60%~40%电量</div>
            {{ item.soc60CarCount }}
          </div>
          <div class="status-item bg4" @click="goenergycarStore(40,item.shortname)">
            <div class="status-label">40%~20%电量</div>
            {{ item.soc40CarCount }}
          </div>
        </div>
        <div class="status-row">
          <div class="status-item bg5" @click="goenergycarStore(20,item.shortname)">
            <div class="status-label">20%~0%电量</div>
            {{ item.soc20CarCount }}
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle.vue';
export default {
  data() {
    return {
      shortlist:[],
      CarStatistics:{}
    };
  },
  components: {
    mTitle,
  },
  mounted() {
    this.getCarStatistics()
    this.gethomecarstatistics()
  },
  methods: {
    goFleetList(fleet,num){
      let obj={
        shortname:fleet
      }
      if(num===1){
        obj.discharge='新能源 (电)'
      }else if(num===2){
        obj.discharge='新能源 (氢)'
      }
      this.$router.push({name:'memberlist',query:{obj: JSON.stringify(obj)}})
    },
    goenergycar(num,type,fleet){
      let obj={}
      obj.shortname=fleet
      switch (type) {
        case 'A':
          obj.workecar='工作中' 
          break;
        case 'B':
          obj.vehstate='启动'
          break;
        case 'C':
          obj.workecar='工作中'
          obj.vehstate='启动'
          break;
        case 'D':
          obj.vehstate='熄火' 
          break;
        case 'E':
          obj.vehstate='其他'
          break;
      }
     switch(num){
      case '1':
      this.$router.push({name:'energycar',query:{obj:JSON.stringify(obj)}})
        break;
      case '2':
      this.$router.push({name:'energycarH',query:{obj:JSON.stringify(obj)}})
        break;
      case '3':
      // this.$router.push({name:'memberlist',query:{shortname:fleet}})
      console.log(123)
        break;
     }  
    },
    goenergycarStore(num,fleet){
      let obj={}
      obj.num=num
      obj.shortname=fleet
      this.$router.push({name:'energycar',query:{obj:JSON.stringify(obj)}})
    },
    async getCarStatistics(){
      const { data } = await this.$http(
        "api1",
        "/home/statistics/eachFleetHomeCarStatistics",
        "get");
        if (data.code != 0) return this.$message.error(data.msg);
        console.log(data);
        this.shortlist=data.data
    },
    async gethomecarstatistics(){
      const { data } = await this.$http(
        "api1",
        "/home/statistics/homeCarStatistics",
        "get");
        if (data.code != 0) return this.$message.error(data.msg);
        console.log(data);
        this.CarStatistics=data.data
    }
  },
};
</script>
<style lang="scss" scoped>
.main-page{
  width: 100%;
  height: 100%;
  .cont{
  width: 100%;
  height: calc(100% - 50px);
  overflow: auto;
  .card-list {
    display: flex;
    margin: 20px;
    padding: 25px;
    background-color: #fff;
    border-radius: 20px;
    font-family: PingFang SC;
    justify-content: space-between;
    .img{
      width: 242px; 
      height: 168px;
      background-image: url(../../assets/statistics/pic_011.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      .img-title{
        font-weight: 600;
        font-size: 150%;
        color: #FFFFFF;
        text-shadow: 0px 0px 18px rgba(68,125,215,0.1);
      }
    }
  }
@mixin card {
  width: 19vw;
  height: 212px;
  position: relative;
  &:nth-child(odd) {
    color: #115b76;
  }
  &:nth-child(even) {
    color: #2f419b;
  }
}
@mixin block {
  background-color: #fff;
  position: absolute;
  width: 8vw;
  height: 52px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  & .row {
    cursor:pointer;
  }
  & .type {
    font-size: 15px;
    margin-right: 10px;
  }
  & .number {
    font-size: 1.7vw;
  }
}
.electric-block {
  @include block;
  left: 20px;
  bottom: 21px;
}
.hydrogen-block {
  @include block;
  right: 20px;
  bottom: 21px;
}
.card-title {
  position: absolute;
  right: 20px;
  bottom: 125px;
  & .type {
    margin-right: 21px;
  }
  & .number {
    font-size: 2.1vw;
    font-weight: 600;
  }
}
@for $i from 1 through 2 {
  .card#{$i} {
    @include card;
    background-image: url(../../assets/statistics/icon_0#{$i}.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.card5{
  background-image: url(../../assets/statistics/pic_02.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 39vw;
    height: 212px;
    padding: 20px;
    box-sizing: border-box;
    .card_cont{
      display: grid;
      grid-template-columns: 32% 32% 32%;
      justify-content: space-between;
      @for $i from 1 through 5 {
        .card_item#{$i} {
          background-image: url(../../assets/statistics/dl_0#{$i}.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          position: relative;
          height: 40px;
          margin-top:10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .num{
            font-size: 70%;
            width: 40px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .name{
            font-size: 70%;
          }
        }
      }
      
    }
}
.desc-title {
  display: flex;
  font-size: 20px;
  align-items: center;
  font-weight: 600;
  margin-bottom: 20px;
}
.desc-item {
  display: flex;
  font-size: 0.8vw;
  margin-bottom: 12px;
  padding: 8px 0;
  cursor: pointer;
  & .item-label {
    margin-right: 10px;
  }
}
.icon {
  width: 12px;
  height: 26px;
  background: #17b6a1;
  border-radius: 6px;
  margin-right: 10px;
}
.status-row {
  display: flex;
  justify-content: space-between;
}
.status-item {
  display: flex;
  font-size: 0.8vw;
  background-color: #e2fffb;
  border-radius: 15px;
  padding: 8px 16px;
  margin-bottom: 12px;
  margin-right: 10px;
  cursor: pointer;
  & .status-label {
    margin-right: 10px;
  }
}
.bg1 {
  background-color: #caffcf;
  cursor: pointer;
}
.bg2 {
  background-color: #e5ffca;
  cursor: pointer;
}
.bg3 {
  background-color: #f8ffca;
  cursor: pointer;
}
.bg4 {
  background-color: #fff2e2;
  cursor: pointer;
}
.bg5 {
  background-color: #ffe7e2;
  cursor: pointer;
}
.elec .status-item {
  min-width: 8vw;
  justify-content: space-between;
}
}
}


</style>
